import {
  FETCH_BOOKINGS_DATA,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILURE,
  FETCH_BOOKINGS_DETAILS_DATA,
  FETCH_BOOKINGS_DETAILS_SUCCESS,
  FETCH_BOOKINGS_DETAILS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  details: {
    loading: false,
    data: null,
    error: null,
  },
};

const bookings = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BOOKINGS_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_BOOKINGS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_BOOKINGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_BOOKINGS_DETAILS_DATA:
      return { ...state, details: { loading: true, data: null, error: null } };
    case FETCH_BOOKINGS_DETAILS_SUCCESS:
      return { ...state, details: { loading: false, data: action.payload, error: null } };
    case FETCH_BOOKINGS_DETAILS_FAILURE:
      return { ...state, details: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
};

export default bookings;
